import React from 'react';
import { connect } from 'react-redux';
import Link from 'components/Link';
import { dateToStringWithFormat } from 'utils/dateUtils';
import s from './CardV4.scss';

class CardV4 extends React.Component {
  render() {
    const { data, datanewga, isMobile = false } = this.props;
    const imgWidth = isMobile ? '375' : '600';
    return (
      <>
        {data && data.logoUrl && data.logoUrl !== '' ? (
          <div className={s.cardv4}>
            <div className={s.topRow}>
              <Link
                to={data.wu}
                className={s.cardv4}
                target="_blank"
                data-newga={`${datanewga}#${data.wu}`}
              >
                <div className={s.liveBtn}>BUDGET LIVE</div>
              </Link>
              {data.logioimageid && (
                <>
                  <span>/</span>
                  <Link
                    to={data.logoUrl ? data.logoUrl : data.wu}
                    target="_blank"
                    data-newga={`${datanewga}#${
                      data.logoUrl ? data.logoUrl : data.wu
                    }`}
                  >
                    <img
                      src={`https://static.toiimg.com/photo/${
                        data.logioimageid
                      }.cms`}
                      alt=""
                    />
                  </Link>
                </>
              )}
            </div>
            <Link
              to={data.wu}
              target="_blank"
              data-newga={`${datanewga}#${data.wu}`}
            >
              <figure className={s.textWrap}>
                <div className={s.imgWrap}>
                  <img
                    src={`https://static.toiimg.com/thumb/imgsize-${
                      data.imagesize ? data.imagesize : '123'
                    },msid-${data.imageid},width-${imgWidth},resizemode-4/${
                      data.imageid
                    }.jpg`}
                    alt=""
                  />
                </div>
                <figcaption>
                  <h5>
                    {dateToStringWithFormat(
                      data.dl,
                      ' DD MMM, YYYY, HH:mm [(IST)]',
                    )}
                  </h5>
                  <p>{data.hl}</p>
                </figcaption>
              </figure>
            </Link>
          </div>
        ) : (
          <Link
            to={data.wu}
            className={s.cardv4}
            target="_blank"
            data-newga={`${datanewga}#${data.wu}`}
          >
            <div className={s.topRow}>
              <div className={s.liveBtn}>BUDGET LIVE</div>
              {data.logioimageid && (
                <>
                  <span>/</span>
                  <img
                    src={`https://static.toiimg.com/photo/${
                      data.logioimageid
                    }.cms`}
                    alt=""
                  />
                </>
              )}
            </div>
            <figure className={s.textWrap}>
              <div className={s.imgWrap}>
                <img
                  src={`https://static.toiimg.com/thumb/imgsize-${
                    data.imagesize ? data.imagesize : '123'
                  },msid-${data.imageid},width-${imgWidth},resizemode-4/${
                    data.imageid
                  }.jpg`}
                  alt=""
                />
              </div>
              <figcaption>
                <h5>
                  {dateToStringWithFormat(
                    data.dl,
                    ' DD MMM, YYYY, HH:mm [(IST)]',
                  )}
                </h5>
                <p>{data.hl}</p>
              </figcaption>
            </figure>
          </Link>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  isMobile: state.isMobile,
});

export default connect(mapStateToProps)(CardV4);
